/**
 * Petits utilitaires communs aux formulaires de la fiche GRV alimentés par un référentiel
 * (`OngletInformations.tsx`, `OngletAction.tsx`) : résoudre la valeur actuelle de la fiche vers un
 * code de référentiel, et garantir que cette valeur reste proposée même absente ou désactivée.
 */

export type OptionReferentiel = { code: string; libelle: string };

/**
 * Résout la valeur actuellement enregistrée sur la fiche vers le code du référentiel : les fiches
 * antérieures à ce menu déroulant portent le libellé saisi en texte libre (« JET A-1 »), pas le code
 * (`jet_a1`). Sans cette résolution, cette ancienne saisie apparaîtrait comme une seconde option au
 * libellé identique plutôt que de sélectionner la bonne entrée du référentiel.
 */
export function resoudreCode(valeurBrute: string, actifs: OptionReferentiel[]): string {
  if (!valeurBrute || actifs.some((option) => option.code === valeurBrute)) return valeurBrute;
  const correspondance = actifs.find(
    (option) => option.libelle.localeCompare(valeurBrute, undefined, { sensitivity: "base" }) === 0,
  );
  return correspondance ? correspondance.code : valeurBrute;
}

/**
 * Options d'un menu déroulant alimenté par un référentiel : la valeur actuelle de la fiche y figure
 * toujours, même désactivée ou absente du référentiel (valeur retirée depuis) — sans quoi rouvrir le
 * formulaire changerait silencieusement ce champ au premier enregistrement.
 */
export function optionsAvecValeurCourante(
  actifs: OptionReferentiel[],
  valeurCourante: string,
): OptionReferentiel[] {
  if (!valeurCourante || actifs.some((option) => option.code === valeurCourante)) return actifs;
  return [{ code: valeurCourante, libelle: valeurCourante }, ...actifs];
}
